import { createContext } from 'react';

const builderContextNew = createContext();

export default builderContextNew;
